import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1016.47059,56 C1514.65412,56 1920,461.345882 1920,959.529412 C1920,1457.71294 1514.65412,1863.05882 1016.47059,1863.05882 C743.265882,1863.05882 488.131765,1741.64706 316.574118,1529.76941 L316.574118,1529.76941 L492.084706,1387.68941 C620.611765,1546.25882 811.821176,1637.17647 1016.47059,1637.17647 C1390.19294,1637.17647 1694.11765,1333.25176 1694.11765,959.529412 C1694.11765,585.807059 1390.19294,281.882353 1016.47059,281.882353 C811.821176,281.882353 620.611765,372.8 492.084706,531.369412 L492.084706,531.369412 L316.574118,389.289412 C488.131765,177.411765 743.265882,56 1016.47059,56 Z M926.930824,484.408471 L1401.96141,959.552 L926.930824,1434.69553 L767.232,1274.88376 L969.735529,1072.49318 L0.0225882353,1072.49318 L0.0225882353,846.610824 L969.735529,846.610824 L767.232,644.107294 L926.930824,484.408471 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconToggleRightSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconToggleRightSolid, _Component);

  var _super = _createSuper(IconToggleRightSolid);

  function IconToggleRightSolid() {
    _classCallCheck(this, IconToggleRightSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconToggleRightSolid, [{
    key: "render",
    value: function render() {
      if (process.env.NODE_ENV !== 'production') {}

      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconToggleRight",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);

  IconToggleRightSolid.displayName = "IconToggleRightSolid";
  return IconToggleRightSolid;
}(Component);

IconToggleRightSolid.glyphName = 'toggle-right';
IconToggleRightSolid.variant = 'Solid';
IconToggleRightSolid.deprecated = true;
IconToggleRightSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconToggleRightSolid;
export { IconToggleRightSolid };